import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import parse from 'html-react-parser';
import UsdmSwitch from './UsdmSwitch';

export default function PanelHeader(props) {
    const { title, addtext=null, buttonValue=null, buttontext, handleButtonClick, showdm=null, setShowdm=null } = props;
   
	return (
		<>
			<Typography variant="h6" component="h2" sx={{m: "0 0 0.5em"}} >
				{title}
				{buttonValue !== null &&
					<Button 
						sx={{ float: "right", textTransform: "capitalize" }}
						value={buttonValue}
						variant="outlined" 
						size="small"
						onClick={handleButtonClick}
					>
						{buttontext}
					</Button>
				}
				{showdm !== null &&
					<UsdmSwitch
						showdm={showdm}
						setShowdm={setShowdm}
						sx={{ float: "right "}}
					/>
				}
			</Typography>
			{addtext &&
				<div>
					<Typography sx={{ lineHeight:"1.25" ,marginBottom:"1em" }}>
						{parse(addtext)}
					</Typography>
				</div>
			}
        </>
	);
}